// React
import React, { Component } from 'react'

// Libraries
import { Provider } from 'react-redux'

// Components
import Themed from 'store/v2/react/components/Themed'
import CartButton from 'store/v2/react/components/cart_button'

// Shared

const store = window.booqableStore

export default class CartButtonContainer extends Component {
  static displayName = 'CartButtonContainer'

  render () {
    return (
      <Provider store={store}>
        <Themed>
          <CartButton {...this.props} />
        </Themed>
      </Provider>
    )
  }
}
